// i18n.ts
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./i18n/extracted/en.json";
import hu from "./i18n/extracted/hu.json";
import de from "./i18n/extracted/de.json";
import sk from "./i18n/extracted/sk.json";

import { missingProfileDataResources } from "@frontend-common/translations/missing-profile-data-translations";
import { zodI18nMap } from "zod-i18n-map";
import deErrors from "zod-i18n-map/locales/de/zod.json";
import skErrors from "zod-i18n-map/locales/sk/zod.json";
import z from "zod";
import { zodHu } from "./i18n/zod-hu";
import { loadZodTranslations } from "@common/schemas/util";

i18n.use(initReactI18next).init({
  lng: "hu",
  resources: {
    en: {
      translation: {
        ...en,
        ...missingProfileDataResources("en"),
        ordinal_one: "{{count}}st",
        ordinal_two: "{{count}}nd",
        ordinal_three: "{{count}}rd",
        ordinal_few: "{{count}}rd",
        ordinal_other: "{{count}}th",
      },
    },
    hu: {
      translation: {
        ...hu,
        ...missingProfileDataResources("hu"),
        ordinal_one: "{{count}}.",
        ordinal_two: "{{count}}.",
        ordinal_three: "{{count}}.",
        ordinal_few: "{{count}}.",
        ordinal_other: "{{count}}.",
      },
      zod: zodHu,
    },
    de: {
      translation: {
        ordinal_one: "{{count}}.",
        ordinal_two: "{{count}}.",
        ordinal_few: "{{count}}.",
        ordinal_three: "{{count}}.",
        ordinal_other: "{{count}}.",
        ...de,
        ...missingProfileDataResources("de"),
      },
      zod: deErrors,
    },
    sk: {
      translation: {
        ordinal_one: "{{count}}.",
        ordinal_two: "{{count}}.",
        ordinal_few: "{{count}}.",
        ordinal_three: "{{count}}.",
        ordinal_other: "{{count}}.",
        ...sk,
        ...missingProfileDataResources("sk"),
      },
      zod: skErrors,
    },
  },
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});

z.setErrorMap(zodI18nMap);
loadZodTranslations();

export type I18n = typeof i18n;
export { i18n };
